<template>
  <div
    class="flex flex-col bg-EXPONDO-white w-full h-full top-0 transition-[left]
      fixed z-50 overflow-y-auto px-6 py-10
      lg:static lg:z-auto lg:overflow-y-visible lg:p-0"
    :class="isFilterModalOpen ? 'left-0' : '-left-full'"
  >
    <ModalHeading
      :title="$t('Filter')"
      class="border-b-2 border-EXPONDO-grey-20 lg:hidden"
      @click-close-icon="toggleFilterModal"
    />

    <SearchFilters
      class="flex-grow overflow-y-auto my-10 lg:my-0 lg:overflow-y-visible"
    />
    <ais-stats
v-slot="{ nbHits }"
class="lg:hidden">
<button
       
        class="btn bg-EXPONDO-gold text-EXPONDO-primary py-3 w-full font-medium rounded"
        @click="toggleFilterModal"
      >
        <span>{{ $t('View n products', { count: nbHits }) }}</span>
      </button>
</ais-stats>
    <div class="pt-4 text-center lg:hidden">
      <ClearRefinements />
    </div>
  </div>
</template>
<script lang="ts">

import { AisStats } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  name: 'FilterModal',
  components: {
    
    AisStats,
  },
  setup() {

    const { isFilterModalOpen, toggleFilterModal } = useUiState();
    const { isMobile } = useUiMode();

    const disableGlobalScroll = computed(() => isFilterModalOpen.value && isMobile.value);
    watch(disableGlobalScroll, (value) => {

      if (value) {

        document.body.classList.add('overflow-y-hidden');
      
      } else {

        document.body.classList.remove('overflow-y-hidden');
      
      }
    
    });

    return {
      isFilterModalOpen,
      toggleFilterModal,
    };
  
  },
});

</script>

<style lang="scss" scoped>
:deep(.heading__close-button) {
  font-size: var(--h2-font-size);
  font-weight: var(--h2-font-weight);
  line-height: var(--h2-line-height);
}
</style>
